import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'mon-panel-header-next',
    template: `
        <div class="mon-panel-header panel-heading py-3 pl-4 card-header" [ngClass]="eClass">
            <div class="d-flex align-items-center">
                <div *ngIf="faIcon" class="pr-2">
                    <span class="fa-2x" [ngClass]="faIcon">
                    </span>
                </div>
                <div class="mr-auto text-ellipsis">
                    <h2 class="font-weight-300 my-0 text-ellipsis" [ngClass]="{'mb-1': subHeader}">
                        <span data-test="module-header" [innerHTML]="pHeader"></span>
                    </h2>
                    <p data-test="module-description" class="text-grey text-ellipsis" *ngIf="subHeader" [innerHTML]="subHeader"></p>
                </div>
                <div [ngClass]="transcludeClass">
                    <ng-content></ng-content>
                </div>
            </div>
            <ng-content select="[slot=header-new-line]"></ng-content>
        </div>
    `,
    standalone: false,
})
export class MonPanelHeaderComponent implements OnInit {
    @Input() pHeader: string = '';
    @Input() subHeader: string = '';
    @Input() faIcon: any = '';
    @Input() eClass: string = '';
    @Input() transcludeClass: string = '';
    @Input() hideHr: boolean = false;

    ngOnInit () {
        this.eClass += this.hideHr ? ' no-border' : '';
    }
}
